// extracted by mini-css-extract-plugin
export default {"primary":"#c2bc37","secondary":"#3b3b3b","info":"#757575","warning":"#ed6c02"};